fx.translations("it", {
    "Ajouter 2 pages" : "Aggiungi 2 pagine",
    "Supprimer 2 pages" : "Eliminare 2 pagine",
    "Votre album ne peut contenir moins de $ pages" : "Il tuo album non può contenere meno di $ pagine",
    "Copier" : "Copiare", 
    "Couper" : "Tagliare",
    
    "Nombre de photos par page" : "Numero di foto per pagina",
    
    "Tout sélectionner" : "Seleziona tutto",
    "Tout déselectionner" : "Deseleziona tutto",
    
    "Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème." : "Se non succede nulla dopo aver cliccato sul pulsante di accesso, significa che il tuo browser blocca i popup. Devi semplicemente permettere al tuo browser di mostrare i popup per risolvere il problema.",
    "Nous avons bientôt fini de récupérer vos photos" : "Stiamo per finire di recuperare le tue foto",
    "On s’occupe de vous rediriger quand c’est terminé" : "Ci occuperemo di reindirizzarti una volta completato",
   
    "Cliquez pour aller à la page" : "Clicca per andare alla pagina",
    
    "Souhaitez-vous commander votre ouvrage dans l'état ?" : "Vuoi ordinare il tuo lavoro così com'è?",
  
    "La couverture a été changée" : "La copertina è stata cambiata",
    "Vérifier que tout est placé correctement sur votre couverture." : "Verifica che tutto sia posizionato correttamente sulla tua copertina.",
    
    "Ce changement de couverture n'est pas possible" : "Questo cambio di copertina non è possibile",
    "mais avec cette couverture votre album ne peut contenir <strong>plus de $ pages</strong>.<br><br> Veuillez supprimer des pages avant de choisir cette couverture." : "ma con questa copertina il tuo album non può contenere <strong>più di $ pagine</strong>.<br><br> Rimuovi alcune pagine prima di scegliere questa copertina.",
    "mais avec cette couverture votre album doit contenir <strong>au moins $ pages</strong>.<br><br> Veuillez ajouter des pages avant de choisir cette couverture." : "ma con questa copertina il tuo album deve contenere <strong>almeno $ pagine</strong>.<br><br> Aggiungi delle pagine prima di scegliere questa copertina.",
    "J'ajoutes vos photos dans votre gallerie" : "Sto aggiungendo le tue foto nella tua galleria",
    "Souhaitez-vous que je crée votre album photo ?" : "Vuoi che io crei il tuo album fotografico?",
    "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Le tue foto saranno posizionate in ordine cronologico,<br>e dovrai solo verificare il tuo album.",
    "Attention : votre contenu sera totalement remplacé." : "Attenzione: il tuo contenuto sarà completamente sostituito.",
    "Oui, Créez mon album" : "Sì, crea il mio album",
    "Non, merci" : "No, grazie",
    "Un instant, je place vos photos..." : "Un momento, sto posizionando le tue foto...",
    "Cet aperçu vous montre comment sera votre album une fois imprimé.<br/>Assurez-vous de n'avoir rien oublié avant de commander." : "Questa anteprima mostra come sarà il tuo album una volta stampato.<br/>Assicurati di non aver dimenticato nulla prima di ordinare.",
    "L'aperçu de votre album est prêt !" : "L'anteprima del tuo album è pronta!",
    "Assurez-vous de n'avoir rien oublié avant de commander." : "Assicurati di non aver dimenticato nulla prima di ordinare.",
    "Vérifier mon album" : "Controlla il mio album",
    "J'ai préparé l'aperçu de votre album" : "Ho preparato l'anteprima del tuo album",
    "Voir l'aperçu" : "Vedi l'anteprima",
    
    "Continuer" : "Continua",

    "Copie en cours" : "Copia in corso",
    "Ca va être rapide !" : "Sarà veloce!",
    
    "Choisissez la finition de votre album" : "Scegli la finitura del tuo album",
    "Quel type d'ouverture souhaitez-vous ?" : "Che tipo di apertura desideri?",
    
    "Choisissez la forme de votre album" : "Scegli la forma del tuo album",
   
    "Grille activée" : "Griglia attivata",
    "Grille désactivée" : "Griglia disattivata",
    "Epaisseur" : "Spessore",

    "Vue Globale" : "Vista Globale",
    "Vue Edition" : "Vista Edizione",

    "Editer" : "Modifica",
    "Prévisualiser" : "Anteprima",

    "Aller directement à l'éditeur" : "Vai direttamente all'editore",
    "$ photos sélectionnées" : "$ foto selezionate",
    "Suivant" : "Successivo",
     
    "Sélectionner les meilleures !" : "Seleziona i migliori!",
    "Tout sélectionner" : "Seleziona tutto",
    "J'ai sélectionné vos photos" : "Ho selezionato le tue foto",
    "Vous pouvez modifier ma sélection avant de lancer la création intelligente de votre album" : "Puoi modificare la mia selezione prima di avviare la creazione intelligente del tuo album",
    "Créer votre album !" : "Crea il tuo album!",
     
    "Votre fichier a été importé" : "Il tuo file è stato importato",
    "Il a été ajouté à vos photos" : "È stato aggiunto alle tue foto",

    "Options" : "Opzioni",

    "+ $ €" : "+ $ €",

    "Couvertures" : "Copertine",
    "Thèmes" : "Temi",
     
    "Mises en page" : "Layout",
     
    "Vue Simple" : "Vista Semplice",
    "Changer la couverture" : "Cambia copertina",
     
    "Sauvegarder en tant que Modèle" : "Salva questo layout",

    "Numéroter les pages" : "Numerare le pagine",
    "Supprimer la numérotation" : "Rimuovi la numerazione",
     
    "J'ai numéroté vos pages" : "Ho numerato le tue pagine",
    "Cliquez pour éditer la taille, la police et la couleur" : "Clicca per modificare dimensione, font e colore",
    "Ok" : "Ok",

    "Changer de modèle" : "Cambia modello",

    "Choisissez la finition de votre album" : "Scegli la finitura del tuo album",

    "Thématique" : "Consigliato",
    "Classique" : "Classico",
    "Sauvegardé" : "Personale",

    "Nombre de photos" : "Numero di foto",

    "Placer vos photos automatiquement" : "Posizionare le tue foto automaticamente",
    "Mises en pages" : "Layout",

    // album preview (desktop.common.preview.BookTable)
    "Dos" : "Retro",
    "Votre album" : "Il tuo album",
    "Retour à l'éditeur" : "Torna all'editor",
    "Vue de face" : "Vista frontale",
    "Vue perspective" : "Vista prospettica",
    "Page précédente" : "Pagina precedente",
    "Page suivante" : "Pagina successiva",
    "Pagination" : "Paginazione",
    "Vue" : "Vista",
    "Aperçu de votre album" : "Anteprima del tuo album",
});
